import { CAPABILITY } from "../../../helpers/permissions";
import { loadEstimates, resolveEstimateStatus } from "../../../helpers/estimates";
import { buildGuestExecutiveBriefingData } from "../executiveBriefingGuestDemo";
import { pluralize } from "../formatBriefingSpeech";

export const ESTIMATES_PROVIDER_ID = "estimates";

async function loadEstimatesSnapshot(ctx) {
  if (ctx.isGuest) {
    return buildGuestExecutiveBriefingData().estimates;
  }

  if (ctx.isOffline || !ctx.actor) {
    return null;
  }

  const rows = await loadEstimates(ctx.actor);
  let draftCount = 0;
  let awaitingApprovalCount = 0;

  for (const row of rows || []) {
    const status = resolveEstimateStatus(row?.status);
    if (status === "draft") {
      draftCount += 1;
    } else if (status === "sent") {
      awaitingApprovalCount += 1;
    }
  }

  return { draftCount, awaitingApprovalCount };
}

export const estimatesProvider = {
  id: ESTIMATES_PROVIDER_ID,
  isEligible(ctx) {
    return ctx.can(CAPABILITY.ESTIMATE_VIEW);
  },
  loadData: loadEstimatesSnapshot,
  buildSection(_ctx, data) {
    if (!data) {
      return null;
    }

    const { draftCount, awaitingApprovalCount } = data;
    const parts = [];

    if (draftCount > 0) {
      parts.push(pluralize(draftCount, "draft estimate"));
    }

    if (awaitingApprovalCount > 0) {
      parts.push(
        pluralize(awaitingApprovalCount, "estimate awaiting client approval", "estimates awaiting client approval"),
      );
    }

    if (parts.length === 0) {
      return null;
    }

    if (parts.length === 1) {
      return `In estimates, you have ${parts[0]}.`;
    }

    return `In estimates, you have ${parts[0]} and ${parts[1]}.`;
  },
};
